import React, { Fragment, PureComponent } from 'react';
import {
  TransitionGroup,
  CSSTransition,
} from 'react-transition-group';
import styled from 'styled-components';

export default class PageTransition extends PureComponent {

  constructor(props) {
    super(props);

    this.transition = React.createRef();
  }

  render() {
    return (
      <TransitionGroup component={null}>
        <CSSTransition
          timeout={{
            enter: this.props.speed,
            exit: this.props.speed,
          }}
          classNames={{
            exit: 'transitioning',
          }}
          key={this.props.route}
        >
          <Fragment>
            {this.props.children}
            <TransitionWrapper ref={this.transition} />
          </Fragment>
        </CSSTransition>
      </TransitionGroup>
    );
  }
}

const TransitionWrapper = styled.div`
  will-change: transform;
  transform: translateY(-5%);
  position: fixed;
  pointer-events: none;
  height: 110vh;
  width: 100%;
  top: 0;
  left: 0;
  z-index: 999;
  opacity: 0;
  background-color: ${props => props.theme.blue};
  transition: opacity .3s ease;

  .transitioning + & {
    opacity: 1;
    transition: none;
    animation: page-transition .42s cubic-bezier(.895, .03, .685, .22);
  }

  @keyframes page-transition {
    0% {
      opacity: 1;
      transform: translateY(100%);
    }

    100% {
      transform: translateY(-5%);
    }
  }
`;
